module.exports = __webpack_public_path__ + "media/hyper/images/layouts/layout-5-49597c9ba3323b052cef9b704f072017.png";